import React, { FC } from 'react'
import { AddIcon } from '@systemeio/ui/icons'
import { twMerge } from 'tailwind-merge'

type Props = {
  onClick: () => void
  caption?: string
  disabled?: boolean
}

export const AddItemIcon: FC<Props> = ({ onClick, caption, disabled = false }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    className={twMerge(
      'text-brand-primary flex w-fit cursor-pointer items-center gap-3 outline-hidden',
      disabled && 'text-text-secondary/50 cursor-default',
    )}
  >
    <AddIcon
      className={twMerge(
        `fill-brand-primary h-[18px] w-[18px]`,
        disabled && 'fill-text-secondary/50',
      )}
    />
    {caption && <span className="lg:hidden">{caption}</span>}
  </button>
)
